import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
	createPostMailingTemplate,
	getPostMailingTemplate,
	updatePostMailingTemplate,
	deletePostMailingTemplate,
} from '../../api/postMailingTemplatesApi';

import { postMailingTemplatesKeys } from './keys';

export function useCreatePostMailingTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createPostMailingTemplate,
		onSuccess: () => qc.invalidateQueries({ queryKey: postMailingTemplatesKeys.all }),
	});
}

export function useUpdatePostMailingTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, payload }) => updatePostMailingTemplate(id, payload),
		onSuccess: () => qc.invalidateQueries({ queryKey: postMailingTemplatesKeys.all }),
	});
}

export function useDeletePostMailingTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deletePostMailingTemplate,
		onSuccess: () => qc.invalidateQueries({ queryKey: postMailingTemplatesKeys.all }),
	});
}

function makeCopyName(originalName, existingNames) {
	const base = originalName.replace(/ \(Kopie( \d+)?\)$/, '');
	const candidates = [`${base} (Kopie)`];
	for (let i = 2; i <= 99; i += 1) candidates.push(`${base} (Kopie ${i})`);
	return candidates.find((c) => !existingNames.has(c)) || `${base} (Kopie ${Date.now()})`;
}

export function useDuplicatePostMailingTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: async (template) => {
			const full = template?.designData
				? template
				: await getPostMailingTemplate(template.id).then((res) => res?.template ?? res);
			const list = qc.getQueryData(postMailingTemplatesKeys.list()) || [];
			const existingNames = new Set(list.map((t) => t.name));
			const newName = makeCopyName(full.name || 'Vorlage', existingNames);
			const designData = JSON.parse(JSON.stringify(full.designData ?? {}));
			return createPostMailingTemplate({ name: newName, designData });
		},
		onSuccess: () => qc.invalidateQueries({ queryKey: postMailingTemplatesKeys.all }),
	});
}
